<template lang="html">
<el-row>
  <el-row :gutter="20">
    <el-col :span="6" style="margin-top:5px;">
      <el-card>
        <p>累计收入金额</p>
        <p> {{statistics.channelTotal/100}} 元 / {{statistics.channelCount}} 笔</p>
      </el-card>
    </el-col>
    <el-col :span="6" style="margin-top:5px;">
      <el-card>
        <p>最近30天收入金额</p>
        <p> {{statistics.thirtyDayChannelTotal/100}} 元 / {{statistics.thirtyDayChannelCount}} 笔</p>
      </el-card>
    </el-col>
    <el-col :span="6" style="margin-top:5px;">
      <el-card>
        <p>昨日收入金额</p>
        <p> {{statistics.yesterdayChannelTotal/100}} 元 / {{statistics.yesterdayChannelCount}} 笔</p>
      </el-card>
    </el-col>
    <el-col :span="6" style="margin-top:5px;">
      <el-card>
        <p>今日收入金额</p>
        <p> {{statistics.todayChannelTotal/100}} 元 / {{statistics.todayChannelCount}} 笔</p>
      </el-card>
    </el-col>
  </el-row>
  <el-card>
    <el-row>
        <free-order-management></free-order-management>
    </el-row>
  </el-card>

</el-row>
</template>

<script>
import channelSelect from '@/components/channelSelect'
import freeOrderManagement from './freeOrderManagement'
import BasicModel from '@/framework/basic/BasicModel'
export default {
  name: 'channel-free-statistics',
  components: {
    channelSelect,
    freeOrderManagement
  },
  data: function () {
    return {

      queryParams: {
        channelId: null
      },
      statistics: {
        channelTotal: 0,
        channelCount: 0,
        thirtyDayChannelTotal: 0,
        thirtyDayChannelCount: 0,
        yesterdayChannelTotal: 0,
        yesterdayChannelCount: 0,
        todayChannelTotal: 0,
        todayChannelCount: 0
      }
    }
  },
  created: function () {
    let userInfo = JSON.parse(localStorage.userInfo)

    this.queryParams.channelId = userInfo.id
    this.selectStatistics()
  },
  methods: {
    selectStatistics: function () {
      let _this = this
      let param = {}

      if (this.queryParams.channelId) {
        param.channelId = this.queryParams.channelId
      }

      let listener = {
        success: function (dataInfo) {
          _this.statistics = dataInfo.datas
        }
      }

      BasicModel.get(this, 'privateUsedCar/selectStatisticsByChannel.action', param, listener)
    }
  }
}
</script>

<style lang="css" scoped>
</style>
